import styled, { css } from "styled-components";
import PButton from "../../../components/PButton";

export const ProductsContainer = styled.div`
  position: relative;
  padding-top: 30px;
  background-color: #7b6e661a;
  padding-bottom: 30px;
  &::before {
    position: absolute;
    content: " ";
    height: 60%;
    width: 100%;
    top: 0px;
  }

  @media only screen and (max-width: 768px) {
    &::before {
      height: 70%;
    }
  }
`;

export const ProductsButton = styled(PButton)`
  margin-left: 50%;
  transform: translateX(-50%);
  margin-top: 30px;
  ${({ theme }) => css`
    border: 3px solid ${theme.colors.darkGray2};
    color: ${theme.colors.darkGray2};
    background-color: ${theme.colors.white} !important;
  `}
`;

export const ImageContainer = styled.div`
  transition: 300ms;
  &:hover {
    transform: scale(1.1) translateY(-30px);
  }
`;
